export var OrdersCompletedSelectOptions;
(function (OrdersCompletedSelectOptions) {
    OrdersCompletedSelectOptions["All"] = "All";
    OrdersCompletedSelectOptions["CompletedOnly"] = "CompletedOnly";
    OrdersCompletedSelectOptions["IncompleteOnly"] = "IncompleteOnly";
})(OrdersCompletedSelectOptions || (OrdersCompletedSelectOptions = {}));
